import React from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableCell,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#003366",
    color: theme.palette.common.white,
    padding: 1,
    fontSize: 12,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: 1,
  },
}));
const TableCardComponent = ({ fieldName, value }) => {
  let filteredObject;
  let filterData = [];

  // Collect all non-ELC keys across every row so the column set is stable
  // even when some rows have a subset of fields (e.g. all-empty CCL rows).
  const allColumnKeys = [
    ...new Set(
      (value || []).flatMap((row) =>
        Object.keys(row).filter((k) => !k.startsWith("ELC"))
      )
    ),
  ];

  value?.forEach((x) => {
    if (Object.values(x).some((x) => x?.length > 0)) {
      // Build the row with every defined column key so empty CCL fields
      // appear as blank cells rather than being silently omitted.
      filteredObject = Object.fromEntries(
        allColumnKeys.map((key) => [key, x[key] ?? ""])
      );

      if (Object.keys(filteredObject).length > 0) {
        filterData.push(filteredObject);
      }
    }
  });

  return (
    <TableContainer component={Paper}>
      <b>
        <u>{fieldName}: </u>
      </b>
      <Table>
        <TableHead>
          <TableRow>
            {allColumnKeys.map((colKey, index) => (
              <StyledTableCell className="cardTableCell" key={index}>
                {colKey}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {filterData.map((value, key) => (
            <TableRow key={key}>
              {Object.values(value).map((cellVal, index) => (
                <StyledTableCell className="cardTableCell" key={index}>
                  {cellVal !== null && typeof cellVal === "object" ? JSON.stringify(cellVal) : cellVal}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableCardComponent;
